import React from "react";
import './DateLine.css';

interface IDateLineProps{
    className?: string;
    label: React.ReactNode;
    onClick?: ()=>void;
}

export const DateLine = ({className, label, onClick}: IDateLineProps)=>{
    return <div className={`commonDateLine ${className ? className : ''}`}>
        <div className="commonDateLine_box">
        
        </div>
        <div className="commonDateLine_label" onClick={onClick}>
            { label }
        </div>
    </div>
}

export const DateLineThin = ({className, label, onClick}: IDateLineProps)=>{
    return <div className={`commonDateLine commonDateLine--thin ${className ? className : ''}`}>
        <div className="commonDateLine_box commonDateLine_box--thin">
        
        </div>
        <div className="commonDateLine_label commonDateLine_label--thin" onClick={onClick}>
            { label }
        </div>
    </div>
}